<template lang="pug">
div
  v-container(fluid).pa-0.pt-12.azul
    v-carousel(cycle='' width='5vh' height='95vh' hide-delimiter-background='' show-arrows-on-hover='' )  
      Galeria_carousel( v-for='item, k of  Novedades.novedades.filter(i => i.etiquetas.indexOf("Destacado") >-1)' :key='k' :item='item')
  v-container(fluid)
  
    v-container
      v-row.justify-center 
        h1.font-weight-bold.mt-10.azul--text.text-center.icono-international.icono-grande( v-html='Proyectos.subtitulo').pt-7.pl-7
      v-row.justify-center 
        h1.font-weight-light.mb-10.ml-8.azul--text.text-center( v-html='Proyectos.titulo')
      v-row( justify='center' align='center' ).fill-height
        Galeria_dialog( v-for='item, k of Novedades.novedades.filter(i => i.etiquetas.indexOf("Proyectos") >-1)' :key='k' :item='item')
    Descargar_catalogo
        
  
</template>
<script>
export default {
  data: ()=>({
 
  }),
  computed: {
    Novedades() {
      return this.$contenido.Novedades || {noticias: []}
    },
    Proyectos() {
      return this.$contenido.Proyectos || {}
    },
    Inicio() {
      return this.$contenido.Inicio || {}
    },
  },
  components: {
    Descargar_catalogo: ()=>import('../inicio/Descargar_catalogo'),
    Galeria_dialog: ()=>import('./componentes/Galeria_dialog'),
    Galeria_carousel: ()=>import('./componentes/Galeria_carousel')

  }
}
</script>